import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard.ts';
import { inject } from '@angular/core';
import {ProfileCompleted} from "./guards/profileCompleted";

export const AppRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layouts/tabs-layout/tabs.routes').then(m => m.TabsRoutes),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/components/login.page').then(m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/components/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'missions',
    loadChildren: () => import('./pages/missions/missions.routes').then(m => m.MissionRoutes),
    canActivateChild: [() => inject(AuthGuard).canActivate() , () => inject(ProfileCompleted).canActivate()],
  },
   {
    path: 'publications',
    loadChildren: () => import('./pages/social-media/social.routes').then(m => m.SocialRoutes),
    canActivateChild: [() => inject(AuthGuard).canActivate() , () => inject(ProfileCompleted).canActivate()],
  },
  {
    path: 'check',
    loadChildren: () => import('./pages/checks/checks.routes').then(m => m.ChecksRoutes),
  },
  {
    path: 'users/:userId',
    loadComponent: () => import('./pages/user-public-profile/user-public-profile.page').then(m => m.UserPublicProfilePage),
    canActivate: [() => inject(AuthGuard).canActivate(), () => inject(ProfileCompleted).canActivate()],
  },
  // {
  //   path: 'mission/:id',
  //   loadChildren: () => import('./pages/mission/').then(r => r.MissionRoutes)
  // }
];
